// @flow
import * as React from 'react';

import styles from './HighlightHeader.module.scss';;


type Props = {
  children: React.Node,
}

const HighlightHeader = ({ children }: Props) => (
  <header className={styles.root}>
    {children}
  </header>
);

export default HighlightHeader;
